export const PAGE = {
  PER_PAGE: 10,
};
